var map = {
  "./km.json": [
    "816383",
    "743153"
  ],
  "./ru.json": [
    "290872",
    "316586"
  ],
  "./bg.json": [
    "911751",
    "516217"
  ],
  "./el.json": [
    "177131",
    "323244"
  ],
  "./en-pt.json": [
    "851336",
    "626005"
  ],
  "./ja.json": [
    "247149",
    "596267"
  ],
  "./sv.json": [
    "856432",
    "556432"
  ],
  "./rw.json": [
    "600780",
    "790061"
  ],
  "./sr.json": [
    "936136",
    "449892"
  ],
  "./lol.json": [
    "686120",
    "924466"
  ],
  "./fr.json": [
    "161893",
    "736769"
  ],
  "./uk.json": [
    "825799",
    "310570"
  ],
  "./as.json": [
    "807938",
    "46048"
  ],
  "./gu.json": [
    "565255",
    "98934"
  ],
  "./kk.json": [
    "11372",
    "114817"
  ],
  "./nb.json": [
    "209166",
    "707039"
  ],
  "./ta.json": [
    "696022",
    "728279"
  ],
  "./ky.json": [
    "259262",
    "705028"
  ],
  "./pl.json": [
    "613170",
    "365125"
  ],
  "./ro.json": [
    "504878",
    "15979"
  ],
  "./ka.json": [
    "556163",
    "585407"
  ],
  "./hu.json": [
    "506684",
    "651629"
  ],
  "./uz.json": [
    "206158",
    "739799"
  ],
  "./or.json": [
    "330289",
    "488323"
  ],
  "./zh-hans.json": [
    "761926",
    "94051"
  ],
  "./hy.json": [
    "664643",
    "999920"
  ],
  "./de.json": [
    "637808",
    "605517"
  ],
  "./pt-pt.json": [
    "211303",
    "760529"
  ],
  "./vi.json": [
    "867286",
    "291363"
  ],
  "./tr.json": [
    "420312",
    "309034"
  ],
  "./da.json": [
    "114935",
    "180562"
  ],
  "./kn.json": [
    "34813",
    "426652"
  ],
  "./mr.json": [
    "688505",
    "824990"
  ],
  "./id.json": [
    "244873",
    "194845"
  ],
  "./lt.json": [
    "468399",
    "497658"
  ],
  "./lv.json": [
    "249887",
    "197821"
  ],
  "./es.json": [
    "989550",
    "737793"
  ],
  "./ko.json": [
    "795108",
    "169798"
  ],
  "./te.json": [
    "295161",
    "646975"
  ],
  "./bn.json": [
    "435609",
    "13016"
  ],
  "./cs.json": [
    "937490",
    "802611"
  ],
  "./boxes.json": [
    "471566",
    "448335"
  ],
  "./my.json": [
    "64917",
    "584067"
  ],
  "./mn.json": [
    "4309",
    "437425"
  ],
  "./sk.json": [
    "669950",
    "277586"
  ],
  "./nl.json": [
    "724900",
    "268011"
  ],
  "./az.json": [
    "194081",
    "213627"
  ],
  "./accents.json": [
    "526389",
    "81660"
  ],
  "./pa.json": [
    "517954",
    "65329"
  ],
  "./pt.json": [
    "175043",
    "709512"
  ],
  "./extra.json": [
    "420442",
    "570557"
  ],
  "./it.json": [
    "750856",
    "53280"
  ],
  "./hi.json": [
    "644021",
    "977269"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 158011;
module.exports = webpackAsyncContext;
